import ApplicationSerializer from 'lumen/serializers/application';

/**
 * Base for list endpoints that follow the JSON:API RFC: the records live under
 * a top-level `data` key, with pagination in `links` and `meta`.
 *
 * `links` is dropped because RESTSerializer would otherwise try to resolve a
 * `link` model for it. Subclasses set `payloadModelName` to the plural model
 * name that the `data` array maps onto.
 */
export default class PaginatedListSerializer extends ApplicationSerializer {
  protected payloadModelName = '';

  modelNameFromPayloadKey(key: string): string {
    if (key === 'data') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
      return super['modelNameFromPayloadKey'](this.payloadModelName);
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    return super['modelNameFromPayloadKey'](key);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeQueryResponse(
    ...args: Parameters<ApplicationSerializer['normalizeQueryResponse']>
  ) {
    const payload = args[2] as Record<string, unknown>;
    if (payload && 'links' in payload) {
      delete payload['links'];
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    return super.normalizeQueryResponse(...args);
  }
}
